module.exports = __webpack_public_path__ + "static/media/supervised_user_circle.c957ce4c.svg";